import { clearAll } from "@/utils/localStorage";

const SET_IS_LOGIN = (state, isLogin) => {
  state.isLogin = isLogin;
  if (!isLogin) {
    clearAll();
  }
};
const SET_BREADCRUMB = (state, breadcrum) => {
  state.breadcrumb = breadcrum;
};

const SET_APP_ID = (state, appId) => {
  state.appId = appId;
};

const SET_IS_IFRAME = (state, payload) => {
  state.isIframe = payload;
};

const SET_USER_INFO = (state, userInfo) => {
  state.userInfo = userInfo;
};

const SET_LIST_LEVEL = (state, danhSachLevel) => {
  state.danhSachLevel = danhSachLevel;
};

const SET_LIST_PERMISSION = (state, listPermission) => {
  state.permissions = listPermission;
};

export default {
  SET_IS_LOGIN,
  SET_BREADCRUMB,
  SET_APP_ID,
  SET_USER_INFO,
  SET_LIST_LEVEL,
  SET_LIST_PERMISSION,
  SET_IS_IFRAME,
};
